// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PNMy","buttons":"Footer_buttons__3faZU"};